import React from 'react'
import {Input} from 'reactstrap';
import _padStart from 'lodash/padStart';


export default class SelectHours extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            start_hour: this.props.start_hour || localStorage.getItem('start_hour') || '14:00',
            end_hour: this.props.end_hour  || localStorage.getItem('end_hour') || '14:00'
        }
    }


    renderHours = () => {
        let result = []
        let minutes = ['00', '15', '30', '45']
        for (let i = 0; i <= 23; i++) {
            result = result.concat(minutes.map((m) => {
                let h = _padStart((i.toString() + ':' + m),5, '0')
                return (
                    <option key={h} value={h}>{h}</option>
                )
            }))
        }
        return result
    }

    updateHours = (selected) => {
        this.setState(selected)
    }

    render() {
        return (
            <div className={'row '}>
                <div className={'col'}>
                    <small>{this.props.t.pick_hour}</small>
                    <Input type="select" name="start_hour" id="start_hour"
                           defaultValue={this.state.start_hour}
                           onChange={(selected) => {
                               this.updateHours({start_hour: selected.currentTarget.value})
                               localStorage.setItem('start_hour', selected.currentTarget.value)
                           }}>
                        {this.renderHours()}
                    </Input>
                </div>
                <div className={'col'}>
                    <small>{this.props.t.return_hour}</small>
                    <Input type="select" defaultValue={this.state.end_hour}
                           onChange={(selected) => {
                               this.updateHours({end_hour: selected.currentTarget.value})
                               localStorage.setItem('end_hour', selected.currentTarget.value)
                           }}  name="end_hour" id="end_hour">
                        {this.renderHours()}
                    </Input>
                </div>
            </div>
        )
    }
}